/**
 * Holds behaviors for artwork detail
 */
let ArtworkDetail = {
	/**
	 * Entry point
	 */
	_init: () => {
		// listen for ready
		document.addEventListener('DOMContentLoaded', ArtworkDetail._ready);
	},
	/**
	 * Document ready
	 */
	_ready: () => {
		// get the artwork link
		const copyable = document.querySelector('.artworkdetail-wrapper-identification-text-artworklink');

		// if it exists
		if (copyable instanceof HTMLElement) {
			// listen for click on it
			copyable.addEventListener('click', ArtworkDetail._copyableClickHandler);
		}
	},
	/**
	 * Copy the link to the clipboard
	 * @param {event object} e 
	 */
	_copyableClickHandler: (e) => {
		// prevent link from being clicked normally
		e.preventDefault();

		// get the link url
		const copyText = document.querySelector('.artworkdetail-wrapper-identification-text-artworklink-text')
		// get the link el
		const copyLink = document.querySelector('.artworkdetail-wrapper-identification-text-artworklink')

		// Copy the text inside the text field
		navigator.clipboard.writeText(copyText.innerText);

		// @see https://css-tricks.com/restart-css-animation/#update-another-javascript-method-to-restart-a-css-animation
		copyLink.classList.remove('copied')
		void copyLink.offsetWidth;
		copyLink.classList.add('copied')
	},
}

// blast offf
ArtworkDetail._init();